// extracted by mini-css-extract-plugin
module.exports = {"Revenue":"Stocks__Revenue_3tfP6 d-none d-sm-block","Title":"Stocks__Title_38Z83","Footer":"Stocks__Footer_3Ge6_","Total":"Stocks__Total_110Oa","Chart":"Stocks__Chart_2-yTY"};